// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__17WS2","content":"styles_content__a3SeR"};